import { useRef, useState } from "hono/jsx";
// deno-lint-ignore no-import-prefix
import Prism from "https://esm.sh/prismjs@1.29.0";
// deno-lint-ignore no-import-prefix
import "https://esm.sh/prismjs@1.29.0/components/prism-typescript";
// deno-lint-ignore no-import-prefix
import "https://esm.sh/prismjs@1.29.0/components/prism-jsx";
// deno-lint-ignore no-import-prefix
import "https://esm.sh/prismjs@1.29.0/components/prism-tsx";

interface CodeBlockProps {
  code: string;
  language?: string;
}

export function CodeBlock({ code, language = "typescript" }: CodeBlockProps) {
  const modalRef = useRef<HTMLDialogElement>(null);
  const [copied, setCopied] = useState(false);

  // Use dangerouslySetInnerHTML to prevent VDOM vs DOM conflicts
  const highlightedCode = Prism.languages[language]
    ? Prism.highlight(code.trim(), Prism.languages[language], language)
    : code.trim();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code.trim());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const openModal = () => {
    if (modalRef.current) {
      modalRef.current.showModal();
    }
  };

  return (
    <>
      <div class="relative group text-sm rounded-lg overflow-hidden border border-white/10 shadow-xl font-mono bg-[#1d1d1d]">
        {/* Inject Prism CSS (if not already present) */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism-tomorrow.min.css"
        />

        {/* Header */}
        <div class="bg-[#1d1d1d] px-4 py-2 flex items-center gap-2 border-b border-white/5">
          <div class="w-2.5 h-2.5 rounded-full bg-red-500/80" />
          <div class="w-2.5 h-2.5 rounded-full bg-yellow-500/80" />
          <div class="w-2.5 h-2.5 rounded-full bg-green-500/80" />

          <div class="ml-auto flex items-center gap-2">
            <span class="text-xs text-white/30 lowercase mr-2">{language}</span>

            {/* Copy Button */}
            <button
              type="button"
              onClick={handleCopy}
              class="btn btn-ghost btn-xs text-white/50 hover:text-white h-6 min-h-0 px-2"
              title="Copy to Clipboard"
            >
              {copied ? <span class="text-success">Copied!</span> : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2">
                  </rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                  </path>
                </svg>
              )}
            </button>

            {/* Expand Button */}
            <button
              type="button"
              onClick={openModal}
              class="btn btn-ghost btn-xs text-white/50 hover:text-white h-6 min-h-0 px-2"
              title="Expand"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="15 3 21 3 21 9"></polyline>
                <polyline points="9 21 3 21 3 15"></polyline>
                <line x1="21" y1="3" x2="14" y2="10"></line>
                <line x1="3" y1="21" x2="10" y2="14"></line>
              </svg>
            </button>
          </div>
        </div>

        <div class="bg-[#2d2d2d] p-4 overflow-x-auto relative">
          <pre class="m-0 p-0 bg-transparent! text-shadow-none!">
            <code
              class={`language-${language} bg-transparent! text-shadow-none! leading-relaxed`}
              dangerouslySetInnerHTML={{ __html: highlightedCode }}
            />
          </pre>
        </div>
      </div>

      {/* EXPAND MODAL */}
      <dialog ref={modalRef} class="modal backdrop:bg-black/50">
        <div class="modal-box w-11/12 max-w-5xl bg-[#1d1d1d] text-white p-0 overflow-hidden border border-white/10 shadow-2xl">
          {/* Modal Header */}
          <div class="px-4 py-3 border-b border-white/10 flex justify-between items-center bg-[#252525]">
            <h3 class="font-bold text-sm opacity-70">Code View</h3>
            <div class="flex gap-2">
              <button
                type="button"
                onClick={handleCopy}
                class="btn btn-sm btn-ghost gap-2"
              >
                {copied ? "Copied!" : "Copy Code"}
              </button>
              <form method="dialog">
                <button type="submit" class="btn btn-sm btn-circle btn-ghost">
                  ✕
                </button>
              </form>
            </div>
          </div>

          {/* Modal Content */}
          <div class="p-6 overflow-auto max-h-[80vh] bg-[#2d2d2d]">
            <pre class="m-0 p-0 bg-transparent! text-shadow-none!">
              <code
                class={`language-${language} bg-transparent! text-shadow-none! text-sm! leading-loose`}
                dangerouslySetInnerHTML={{ __html: highlightedCode }}
              />
            </pre>
          </div>
        </div>
        <form method="dialog" class="modal-backdrop">
          <button type="button">close</button>
        </form>
      </dialog>
    </>
  );
}
